import React from 'react';
import Loader from 'react-loader-spinner';
import './index.scss';

// type Size = 'small' | 'median' | 'large';
const sizes = {
  large: 300,
  small: 100,
  median: 200,
};

const Loading = ({ size, type }) => {
  return (
    <Loader
      type={type ?? 'Rings'}
      color={'#f49e63'}
      height={size ? sizes[size] : sizes.large}
      width={size ? sizes[size] : sizes.large}
      className="loading"
    />
  );
};

export default Loading;
